import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo, useMemo } from 'react';
import { GpsFixed, GpsOff } from '@mui/icons-material';
import { Box } from '@mui/material';
import { ResponsiveIcon } from '../../icon/responsive';
export function getGPSSignal({ gps, last_gps }) {
    const hdop = gps && gps?.state === 2 ? gps.hdop : last_gps?.hdop;
    if (hdop != null) {
        if (hdop <= 3) {
            return {
                label: 'Отличный',
                icon: GpsFixed,
            };
        }
        if (hdop <= 5) {
            return {
                label: 'Хороший',
                icon: GpsFixed,
            };
        }
        if (hdop <= 8) {
            return {
                label: 'Удовлетворительный',
                icon: GpsFixed,
            };
        }
        return {
            label: 'Слабый',
            icon: GpsFixed,
        };
    }
    return {
        label: 'Нет сигнала',
        icon: GpsOff,
    };
}
const IconElement = memo(forwardRef((props, ref) => {
    const { gps, last_gps, ...rest } = props;
    const { icon } = useMemo(() => getGPSSignal({ gps, last_gps: last_gps?.[0] }), [gps, last_gps]);
    return _jsx(ResponsiveIcon, { Icon: icon, ...rest, ref: ref });
}));
IconElement.displayName = 'IconElement';
export const GPSIcon = memo(function GPSIcon(props) {
    const { gps, online, open, last_gps, ...rest } = props;
    return (_jsx(Box, { display: "flex", alignItems: "center", columnGap: 0.5, onClick: open, children: _jsx(IconElement, { color: online ? 'action' : 'disabled', gps: gps, last_gps: last_gps, ...rest }) }));
});
